// extracted by mini-css-extract-plugin
export default {"container":"PEnFEX","text":"OUF5HS","textFail":"Z_JMoX","forceError":"ZlksR0","absTooltip":"xEOD5g"};